import React, { useMemo } from "react";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { editAccountTooltipThemeOverrides } from "./editAccountTooltipStyles";
import { ACCOUNT_DETAIL_FONT_FAMILY } from "./accountDetailTypography";

/** Shared MUI theme for Configuration / Cloud Accounts (Inter + dark tooltips). */
export const AccountDetailThemeProvider = ({ children }) => {
  const parentTheme = useTheme();
  const theme = useMemo(
    () =>
      createTheme(parentTheme, {
        typography: {
          fontFamily: ACCOUNT_DETAIL_FONT_FAMILY,
        },
        components: editAccountTooltipThemeOverrides,
      }),
    [parentTheme]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
